export default "__VITE_ASSET__BnnrnTT$__"